<template>
  <div class="webzineCatagory__innerbanner">
    <webzine-magazine-article-media
      :desktop-video-src="initialdata?.desktopMp4.src"
      :mobile-video-src="initialdata?.mobileMp4.src"
      :desktop-img-src="initialdata.desktopImage.src"
      :mobile-img-src="initialdata.mobileImage.src"
      :desktop-img-alt="initialdata.desktopImage.alt"
      :scallingmedia-class="true"
      :bannerindex="bannerindex"
    >
    </webzine-magazine-article-media>
    <div
      class="webzineCatagory__bannerContent"
      :class="initialdata.contentColor"
    >
      <div
        class="webzineCatagory__bannerContent_section"
        :class="initialdata.textAlignment"
      >
        <div class="webzineCatagory__bannerContent_text">
          <div class="webzineCatagory__bannerContent_ribbon">
            {{ initialdata.ribbon }}
          </div>
          <h2 class="webzineCatagory__bannerContent_title">
            {{ initialdata.title }}
          </h2>
          <a
            class="webzineCatagory__bannerContent_link"
            v-hrefsafe="initialdata.cta.src"
            :target="initialdata.cta.target"
            @click="dataLayerPush(initialdata.readNowTagging)"
            v-if="initialdata.cta.label"
            >{{ initialdata.cta.label }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import webzineMagazineArticleMedia from './webzine-magazine-article-media.vue';
export default {
  name: 'webzineMagazineBanner',
  props: {
    initialdata: {
      type: [Object, Array],
      required: true,
    },
    bannerindex: {
      type: Number,
      default: 0,
    },
  },
  components: {
    webzineMagazineArticleMedia,
  },
   methods: {
    dataLayerPush(taggingVal) {
      try {
        const eventData = typeof taggingVal === "string" ? JSON.parse(taggingVal) : taggingVal;
        window.dataLayer.push(eventData);
      } catch (error) {
        console.warn('Failed to parse tagging:', error);
      }
    }
   },

};
</script>
